import {FieldConfig} from '../../dynamic-field/field.config';

export interface CheckboxFieldConfig extends FieldConfig<boolean> {
    indeterminate?: boolean;
}
